up.compiler('[pane-view-sidebar]', function(paneViewSidebar) {
  const $paneViewSidebar = $(paneViewSidebar)

  function setHeight() {
    const clientHeight = document.documentElement.clientHeight
    const paneViewSidebarTop = $paneViewSidebar.offset().top
    const paneViewMarginBottom = parseInt($paneViewSidebar.css('marginBottom'))
    $paneViewSidebar.height(clientHeight - paneViewSidebarTop - paneViewMarginBottom)
  }

  // The container size will only be rendered in the next frame
  up.util.task(setHeight)

  $(window).on('resize', setHeight)

  return function() {
    $(window).off('resize', setHeight)
  }

})
